// #140 (owner 2026-10-18 15:57): an expired session (/users/me 401 → /auth/refresh 401) must
// clear the session and land on /login?msg=session-expired, never a blank page.
export const SESSION_EXPIRED_URL = '/login?msg=session-expired';

// Pages that work without a session: never redirect away from them (no loop on /login).
export const PUBLIC_PATHS = ['/login', '/setup-password', '/reset-password', '/forgot-password',
    '/vendor-assessment'];

// Session-scoped browser state (routing helpers / UX flags, never tokens).
const SESSION_KEYS = ['tenant_id', 'admin_token'];

export const isPublicPath = (pathname) =>
    PUBLIC_PATHS.some((p) => String(pathname || '').includes(p));

let expiring = false;

// Clear the session and redirect once. `win` is injectable for tests.
// Returns the URL it navigated to, or null when it stayed (public page / already expiring).
export function expireSession(win = window) {
    try {
        SESSION_KEYS.forEach((k) => win.localStorage.removeItem(k));
    } catch (e) { /* storage unavailable: the redirect still happens */ }
    try {
        win.dispatchEvent(new win.CustomEvent('session-expired'));
    } catch (e) { /* no listener: the redirect below still happens */ }
    if (expiring || isPublicPath(win.location.pathname)) return null;
    expiring = true;
    win.location.replace(SESSION_EXPIRED_URL);
    return SESSION_EXPIRED_URL;
}

// Test hook only.
export function _resetSessionExpiry() {
    expiring = false;
}
